import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import useAuth from "../../hooks/auth/useAuth";
import Loading from "../Loading/Loading";


const Index = () => {

  /* Comment to push Huzeirs changes to Vercel  */
  const location = useLocation();
  const { isLoading } = useAuth(); // Use the useAuth hook to get user data

  useEffect(() => {
    // Redirect to '/home' when on '/' (ensures page refresh goes to home)
    if (location.pathname === "/") {
      window.location.href = "/home";
    }
  }, [location]);

  if (isLoading) return <Loading />;

  return (
    <div>
        <Header />
        <Outlet />
        <Footer />
    </div>
  );
};

export default Index;
